import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ACCOUNT_ROLES } from 'src/constants/globalConstants';
import { PAGES } from 'src/constants/pages';
import { authSelector } from 'src/redux/selectors';
import { TUserWorkspace } from 'src/interfaces/workspacesReduxShapes';

const publicRoutes = [
  PAGES.SIGN_IN,
  PAGES.CHANGE_PASSWORD_SUCCESS,
  PAGES.CONFIRM_PASSWORD_RECOVERY,
  PAGES.PASSWORD_RECOVERY
];

const PublicRouteRender = ({ component: Component, isAuth, role, path, selectedWorkspace, ...rest }): JSX.Element => {
  const { redirectInProgress } = useSelector(authSelector);

  if (isAuth && publicRoutes.includes(path) && !redirectInProgress) {
    if (role === ACCOUNT_ROLES.COMPANY) {
      return <Redirect to={{ pathname: PAGES.WORKSPACES_MANAGEMENT }} />;
    }

    if (role === ACCOUNT_ROLES.USER) {
      return <Redirect to={{ pathname: selectedWorkspace ? PAGES.DASHBOARD : PAGES.WORKSPACES_CHOOSE }} />;
    }

    if (role === ACCOUNT_ROLES.MULTIUSER) {
      return <Redirect to={{ pathname: PAGES.CHOOSE_ACCOUNT_TYPE }} />;
    }
  }

  return <Component {...rest} />;
};

interface ProtectedRouteProps {
  component;
  role: ACCOUNT_ROLES;
  isAuth: boolean;
  exact: boolean;
  path: string;
  selectedWorkspace: TUserWorkspace | null;
}

const PublicRoute = ({
  component,
  isAuth,
  path,
  exact,
  role,
  selectedWorkspace,
  ...rest
}: ProtectedRouteProps): JSX.Element => {
  return (
    <Route
      {...rest}
      path={path}
      exact={exact}
      render={(props) => (
        <PublicRouteRender
          component={component}
          isAuth={isAuth}
          role={role}
          path={path}
          selectedWorkspace={selectedWorkspace}
          {...props}
        />
      )}
    />
  );
};

export default PublicRoute;
